module.exports = __webpack_public_path__ + "static/media/cbse2026.281be77d.jpg";